import { gql } from '@apollo/client';

export const GET_USERS_BY_ADDRESSES = gql`
  query GetUsersByAddresses($addresses: [String!]!) {
    getUsersByAddresses(addresses: $addresses) {
      address
      stoodioUsername
      ensName
      pfp
    }
  }
`;
